import { render } from "./SafetyFAQ.vue?vue&type=template&id=840d4e70"
import script from "./SafetyFAQ.vue?vue&type=script&lang=ts"
export * from "./SafetyFAQ.vue?vue&type=script&lang=ts"
script.render = render

export default script